import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import {
  getBaseAreaData,
  getBaseData,
  getPhoneNumber,
  login,
  validateHoliday,
} from "@service/commonService"
import { getQueryParams } from "@src/util"
import Holiday from "@component/Holiday"
import { goto, gotor } from "@src/route"
import "./flexible"
import "@src/assets/style/index.scss"
import { ignoreAuthPaths } from "./config"

const query = getQueryParams()
const root = document.getElementById("root")
async function init() {
  const { pathname } = location
  if (ignoreAuthPaths.map((res) => res.path).includes(pathname) && root) {
    ReactDOM.createRoot(root).render(<React.Fragment>
      <App />
    </React.Fragment>)
    return
  }
  const v = await validateHoliday()
  if (v.errcode === 1000&&root) {
    return ReactDOM.createRoot(root).render(<React.Fragment>
      <Holiday time={v.errmsg} />
    </React.Fragment>)
  }
  await login(query["token"]).then(() => {
    // 获取基础配置数据
    getBaseData().then(() => null)
    getBaseAreaData().then(() => null)
    getPhoneNumber().then(() => null)
  })

 root&& ReactDOM.createRoot(root).render(<React.Fragment>
  <App />
</React.Fragment>)
}

init().catch((err: any) => {
  if (err?.errcode === 502) {
    gotor("/ins?type=upgrade")
  } else {
    goto("/loginError")
  }

  root&&ReactDOM.createRoot(root).render(    <React.Fragment>
    <App />
  </React.Fragment>)
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
